export const QUIZ_QUESTIONS = {
  HEADACHE_FREQ: "headachesFrequency",
  HEADACHE_DURATION: "headachesDuration",
  HEADACHE_COUNT: "headachesAttackCount",
  FREE_BTW_ATTACKS: "headachesFreeBetweenAttacks",
  HEADACHE_TO_MAX: "headacheGoesToMaximumIn",
  CHANGED_IN_LAST_MONTH: "headachesChangedInLastMonth",
  CHANGED_IN_LAST_MONTH_NOTES: "headachesChangedInLastMonthsNotes",
  HEADACHE_INTENSITY: "headachesIntensity",
  HEADACHE_LOCATION: "headachesLocation",
  PAIN_DESC: "painDescription",
  TYPES_OF_HEADACHE: "experiencedTypesOfHeadache",
  STARTS_AFTER: "headacheStartsAfter",
  HEADACHE_SYMPTOMS: "headacheSymptoms",
  AURA_BUILD_IN: "aurasBuildIn",
  ASSOC_WITH_AURA: "associationWithAura",
  FAMILY_MEMBERS: "familyMembersWithHeadaches",
  FAMILY_TREATMENTS: "familyMembersWithHeadachesNotes",
  WAKE_UP_AT_NIGHT: "headachesWakeUpAtNight",
  TIME_OF_DAY: "timeOfDayWhenHeadachesCome",
  LIFESTYLE_TRIGGERS: "lifestyleTriggers",
  ENVIRONMENTAL_TRIGGERS: "environmentalTriggers",
  VISITED_DOCTOR: "visitedHealthcareDoctor",
  HAD_TESTS: "hadTests",
  TRIED_MEDICATION: "everTriedMedication",
  OTHER_TREATMENTS: "otherTreatmentWays",
  LIFESTYLE_CHOICES: "lifestyleChoices",
  STRESSFUL_EVENTS: "stressfulEvents",
  HAS_DEPRESSION: "hasDepression",
  SEX: "gender",
  HEIGHT: "height",
  FEET: "feet",
  INCHES: "inches",
  WEIGHT: "weight",
  LBS: "lbs",
  BLOOD_PRESSURE: "bloodPressure",
  INPUT_VALUE_TRUE: "true",
  INPUT_VALUE_FALSE: "false",
  FULL_PRESSURE: "fullPressure",
  PULSE: "pulse",
  HEALTH_CONDITIONS: "healthConditions",
  RELATIVE_MEDICAL_HISTORY: "relativesMedicalHistory",
  HAS_OTHER_CONDITIONS: "hasOtherHealthConditions",
  OTHER_CONDITIONS: "otherHealthConditions",
  TAKING_MEDICATIONS: "takingMedicationsOrSupplements",
  MEDICATIONS_OR_SUPPLEMENTS: "medicationOrSupplements",
  HAS_ALLERGIES: "hasAllergies",
  ALLERGIES: "allergies",
  ALLERGIES_NOTES: "allergiesNotes",
  SURGERIES: "hadSurgeriesOrInjuries",
  LAST_DOCTOR_VISIT: "lastDoctorVisitedTime",
  ADDITIONAL_NOTES: "hasAdditionalNotes",
  MULTI_SELECT_MEDICATIONS: "multiSelectMedications",
  TAKING_MEDICATIONS_CONSISTENTLY: "takingMedicationConsistentlyAndIsSatisfied",
  EXPERIENCING_NEW_SIDE_EFFECTS: "experiencingNewSideEffects",
  MAJOR_HEALTH_OR_LIFESTYLE_CHANGE: "majorHealthOrLifestyleChange",
  NEW_MEDICATION_OR_ALLEGIES_CONDITIONS: "newMedicationOrAllergiesOrMedicalConditions",
  QUESTIONS_FOR_DOCTOR: "hasQuestionForDoctor",
  INSURANCE_CARDHOLDER_ID: "insuranceCardholderId",
  INSURANCE_CARDHOLDER_FIRST_NAME: "insuranceCardholderFirstName",
  INSURANCE_CARDHOLDER_LAST_NAME: "insuranceCardholderLastName",
  INSURANCE_BIN: "insuranceBin",
  INSURANCE_PCN: "insurancePcn",
  INSURANCE_GROUP_NUMBER: "insuranceGroupNumber"
}

export const TEST_MARKER_CONSTANTS = {
  DRUG_TYPE_PREFIX: "drugType_",
  REVIEW_TYPE_PREFIX: "reviewDrugType_",
  ADD_BUTTON: "addButton",
  REMOVE_BUTTON: "removeButton",
  GET_STARTED_BUTTON: "getStartedButton",
  MOBILE_GET_STARTED_BUTTON: "mobileGetStartedButton",
  REVIEW_PLAN_BUTTON: "reviewPlanButton",
  MOBILE_REVIEW_PLAN_BUTTON: "mobileReviewPlanButton",
  CYOM_BUTTON: "cyomButton",
  LTDD_BUTTON: "ltddButton",
  FORM_FIRST_NAME: "formFirstName",
  FORM_LAST_NAME: "formLastName",
  FORM_EMAIL: "formEmail",
  VIDEO_UPLOAD_INTRO_CONTINUE_BUTTON: "videoUploadIntroContinueButton",
  MOBILE_VIDEO_UPLOAD_INTRO_CONTINUE_BUTTON: "mobileVideoUploadIntroContinueButton",
  CONTINUE_BUTTON: "continueButton",
  MOBILE_CONTINUE_BUTTON: "mobileContinueButton",
  PASSWORD: "formPassword",
  PASSWORD_CONFIRM: "formPasswordConfirm",
  BIRTH_DATE: "formBirthDate",
  SEX: "formGender",
  STATE: "formState",
  HOW_YOU_HEARD: "formHowYouHeard",
  TERMS_CHECK: "formTermsCheck",
  NEXT_BUTTON: "nextButton",
  MOBILE_NEXT_BUTTON: "mobileNextButton",
  CHECKOUT_BUTTON: "checkoutButton",
  MOBILE_CHECKOUT_BUTTON: "mobileCheckoutButton",
  ADDRESS_1: "address1",
  ADDRESS_2: "address2",
  CITY: "city",
  ZIP_CODE: "zipCode",
  PHONE_NUM: "phoneNum",
  NAME_ON_CARD: "nameOnCard",
  CARD_ELEMENT: "cardElement",
  BILLING_ZIP_CODE: "billingZipCode",
  SUBMIT_ORDER: "submitOrder",
  MOBILE_SUBMIT_ORDER: "mobileSubmitOrder",
  START_BUTTON: "startButton",
  MOBILE_START_BUTTON: "mobileStartButton",
  VIDEO_CONTINUE_BUTTON: "videoContinueButton",
  MOBILE_VIDEO_CONTINUE_BUTTON: "mobileVideoContinueButton",
  VIDEO_FILE_INPUT: "videoFileInput",
  VIDEO_UPLOAD_BUTTON: "videoUploadButton",
  MOBILE_VIDEO_UPLOAD_BUTTON: "mobileVideoUploadButton",
  UPLOADING_BUTTON: "uploadingButton",
  MOBILE_UPLOADING_BUTTON: "mobileUploadingButton",
  UPLOAD_COMPLETE_BUTTON: "uploadCompleteButton",
  IMAGE_UPLOAD_BUTTON: "imageUploadButton",
  IMAGE_UPLOADED_BUTTON: "imageUploadedButton",
  IMAGE_FILE_INPUT: "imageFileInput",
  EXPAND_PRODUCTS_LIST_BUTTON: "expandProductsListButton",
  APPROVE_BUTTON: "approveButton",
  MOBILE_APPROVE_BUTTON: "mobileApproveButton",
  SIGN_IN_EMAIL: "signInEmail",
  SIGN_IN_PASSWORD: "signInPassword",
  SIGN_IN_SUBMIT_BUTTON: "signInSubmitButton",
  TREATMENT_PLAN_NOTIFICATION: "treatmentPlanNotification",
  TREATMENT_PLAN_CONFIRM_BUTTON: "treatmentPlanConfirmButton",
  TREATMENT_PLAN_CONFIRM_BUTTON_MOBILE: "treatmentPlanConfirmButtonMobile",
  EDIT_ORDER_ON_CHECKOUT_LINK: "editOrderOnCheckoutLink",
  PRODUCT_CHECKOUT_ITEM: "productCheckoutItem",
  STEP_NAV_ITEM: "stepNavItem",
  RENEWAL_CONFIRM_PLAN: "renewalConfirmPlan",
  RENEWAL_CONFIRM_BACK: "renewalConfirBack",
  ANNUAL_RENEWAL_NOTIFICATION: "annualRenewalNotification",
  ANNUAL_RENEWAL_CONSULT_PENDING_NOTIFICATION: "annualRenewalConsultPendingNotification",
  DASHBOARD_FINISH_QUIZ_CTA: "dashboardFinishQuizCTA",
  DASHBOARD_FINISH_UPLOAD_MEDIA_CTA: "dashboardFinishUploadMediaCTA",
  PILLPACK_BUTTON: "pillPackButton",
  LOCAL_PHARMACY_BUTTON: "localPharmacyButton",
  MESSAGE_DOCTOR: "messageDoctor",
  MESSAGE_DOCTOR_FIELD: "messageDoctorField",
  MESSAGE_DOCTOR_BUTTON: "messageDoctorButton",
  RIGHT_NAV_PANEL: "rightNavPanel",
  RIGHT_MENU_DASHBOARD: "rightMenuDashboard",
  RIGHT_MENU_USER_EDIT: "rightMenuUserEdit",
  RIGHT_MENU_REFER_FRIEND: "rightMenuReferFriend",
  RIGHT_MENU_LEGALS: "rightMenuLegals",
  USER_EDIT_FIRST_NAME: "userEditFirstName",
  USER_EDIT_LAST_NAME: "userEditLastName",
  USER_EDIT_PHONE_NUMBER: "userEditPhoneNumber",
  USER_EDIT_EMAIL: "userEditEmail",
  USER_EDIT_DOB: "userEditDOB",
  USER_EDIT_SAVE_BUTTON: "userEditSaveButton",
  USER_EDIT_STREET_ADDRESS_1: "userEditStreetAddress1",
  USER_EDIT_STREET_ADDRESS_2: "userEditStreetAddress2",
  USER_EDIT_CITY: "userEditCity",
  USER_EDIT_STATE: "userEditState",
  USER_EDIT_ZIPCODE: "userEditZip",
  USER_EDIT_CHANGE_PAYMENT_METHOD: "userEditChangePaymentMethod",
  USER_EDIT_BILLING_ZIP: "userEditBillingZip",
  USER_EDIT_NAME_ON_CARD: "userEditNameOnCard",
  CONSULTATION_QUIZ_LOCAL_PHARMACY_SEARCH: "consultationQuizLocalPharmacySearch",
  INSURANCE_CONFIRM_INSURANCE: "insuranceConfirmInsurance",
  PRICING_DISCOUNT_PRICE: "pricingDiscountPrice",
  PRICING_FULL_PRICE: "pricingFullPrice"
}
